export default __webpack_public_path__ + "static/media/1-oz-gold-bar-valcambi-suisse-9999-fine-in-assay--132083450098878590.a777fec2.jpg";